<template>
  <div class="container">
    <header class="margin">
      <el-row>
        <el-col :span="7">
          <div class="grid-content bg-purple logo">
            <router-link to="/">
              <!-- <img src="../assets/img/logo.png" /> -->
              <img src="../assets/img/logo.jpg"  style="width:304px"/>
            </router-link>
          </div>
        </el-col>
        <el-col :span="13" style="width: ">
          <div
            class="grid-content bg-purple-light"
            style="width: 920px; height: 90px"
          >
            <ul class="nav">
              <li @click="handleHonme"><a href="javascript:;">首页</a></li>
              <li
                v-for="(nav, index) in list"
                :key="index"
                @mouseenter="handleadEnter(index)"
                @mouseleave="handleadLeave(index)"
                class="navli"
              >
                <a href="javascript:;" @click="handleFaPath(nav)">{{
                  nav.name
                }}</a>
                <ul
                  class="submenu"
                  v-if="index !== 1 && nav.child && index === isActive"
                >
                  <li
                    v-for="(item, index) in nav.child"
                    :key="index"
                    style="width: 100%"
                  >
                    <a
                      href="javascript:;"
                      @click="handleRouter(index, item, nav)"
                      >{{ item.name }}</a
                    >
                  </li>
                  <div style="clear: both"></div>
                </ul>
              </li>
            </ul>
          </div>
        </el-col>
        <!-- 这里是引入的组件 -->
        <div class="popFa" @mouseleave="isActive = ''">
          <promenu @hasUpdatePro="changeProName" v-show="isActive == 1" class="pop"></promenu>
        </div>
        <el-col :span="1" style="height: 90px; line-height: 90px">
          <div>
            <!-- <el-input
              v-model="input"
              class="search"
              placeholder="请输入内容"
              @keyup.enter.native="handleSearch()"
            ></el-input> -->
            <a style="cursor: pointer; position: absolute; right: -11px; top: 0" @mouseover="handeleMouseShow">
              <i class="el-icon-search"></i>
            </a>
          </div>
        </el-col>
      </el-row>
    </header>
    <div style="height: 1px; clear: both"></div>
    <div class="searchAdd" @mouseleave="handleleaveHide">
      <div class="seaechBox">
        <el-input
          placeholder="输入关键字"
          v-model="input"
          
          @keyup.enter.native="handleSearch()"
        >
          <template slot="append" ><div @click="handleSearch()">搜索</div></template>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
/* *
 这里是下拉菜单
*/
import Promenu from "./promenu";
import { signCrypto } from "../utils/generateSecretKey";
export default {
  name: "keepAlive",
  data() {
    return {
      flag: true,
      aboutUs: [],
      input: "",
      navlist1: [],
      list: "",
      isActive: "",
      mid: "",
      proname: "",
    };
  },
  components: {
    Promenu,
  },
  
  methods: {
    changeProName(name) {
      this.isActive=''
    },
    //展示搜索框
    handeleMouseShow(){
      window.document.querySelector('.searchAdd').style.display = 'block'
    },
    handleleaveHide(){
      window.document.querySelector('.searchAdd').style.display = 'none'
    },
    // 搜索
    handleSearch() {
      let id = JSON.parse(sessionStorage.getItem("listTit"))[3].id;
      if (this.input) {
        this.$router.replace({
          name: "searchNewsDel",
          query: { id, val: this.input },
        });
      }
    },
    handleHonme() {
      this.$router.push({ path: "/home" });
    },
    handleadEnter(index) {
      this.isActive = index;
    },
    handleadLeave(index) {
      if (index == 1) {
        this.isActive = index;
      } else {
        this.isActive = "";
      }
    },
    saveSideTit() {
      const data = {
        signField: [],
        pid: "",
      };
      const params = signCrypto(data);
      this.$methods
        .http("/news/achieve_news_category", params, "get")
        .then((res) => {
          if (res.data[0].type === "0") {
            // 分类
            this.saveSideNav(res.data[0].id);
          }
        });
    },
    saveSideNav(pid) {
      const data = {
        signField: ["pid"],
        pid,
      };
      const params = signCrypto(data);
      this.$methods
        .http("/news/achieve_news_category", params, "get")
        .then((res) => {
          this.aboutUs = res.data;
        });
    },
    handleFaPath(v) {
      if (v.name == "关于我们") {
        this.$EventBus.$emit("aboutUs");
        this.$router.push({ name: "aboutUs" });
      }
      if (v.name == "新闻资讯") {
        this.$EventBus.$emit("news");
        this.$router.push({ name: "news" });
      }
      if (v.name == "服务案例") {
        this.$EventBus.$emit("serverCase");
        this.$router.push({ name: "serverCase" });
      }
      if (v.name == "产品&解决方案") {
        this.$router.replace({ name: "design" });
      }
      if (v.name == "加入连邦") {
        this.$router.replace({ path: "/joinUs" });
      }
      if (v.name == "联系我们") {
        this.$router.replace({ path: "/connectUs" });
      }
    },
    /* 跳转路由子页面 */
    handleRouter(index, v, e) {
      if (e.name == "关于我们") {
        if (v.type == "0") {
          this.$router.push({
            name: "aboutUs",
            query: {
              data: v.id,
              val: index,
            },
          });
        }
        if (v.type == "1") {
          // 单条详情
          this.$router.replace({
            name: "inFor",
            params: {
              data: v.id,
            },
            query: {
              val: index,
            },
          });
          if (v["con_list_type"] == "0") {
            this.$router.replace({
              name: "inFor",
              params: {
                data: v.id,
              },
              query: {
                val: index,
              },
            });
          }
        }
      }

      /* 服务案例 */

      if (e.name == "服务案例") {
        if (v.type == "0") {
          if (v["con_list_type"] == "0") {
            this.$router.push({
              name: "serverList",
              params: {
                id: v.id,
              },
              query: {
                val: index,
              },
            });
          }
        }
        // 这是多条图文列表
        if (v.type == "0") {
          if (v["con_list_type"] == "1") {
            this.$router.push({
              name: "serverCaseInFrom",
              params: {
                id: v.id,
              },
              query: {
                val: index,
              },
            });
          }
        }
        // 这是单条文本
        if (v.type == "1") {
          this.$router.push({
            name: "serverCaseInFor",
            params: {
              id: v.id,
            },
            query: {
              val: index,
            },
          });
        }
      }

      /* 新闻资讯 */
      if (e.name == "新闻资讯") {
        // 这是多条文本列表
        if (v.type == "0") {
          if (v["con_list_type"] == "0") {
            this.$router.push({
              name: "textList",
              params: {
                id: v.id,
              },
              query: {
                val: index,
              },
            });
          }
        }
        // 这是多条图文列表
        if (v.type == "0") {
          if (v["con_list_type"] == "1") {
            this.$router.push({
              name: "newsInFrom",
              params: {
                id: v.id,
              },
              query: {
                val: index,
              },
            });
          }
        }
        // 这是单条文本
        if (v.type == "1") {
          this.$router.push({
            name: "newsInFor",
            params: {
              id: v.id,
            },
            query: {
              val: index,
            },
          });
        }
      }
    },
    setTitle() {
      const data = {
        signField: [],
        pid: "",
        is_menu: 2,
      };
      const params = signCrypto(data);
      this.$methods
        .http("/news/achieve_news_category", params, "get")
        .then((res) => {
          this.list = res.data;
        });
    },
  },
  created() {
    this.saveSideTit();
    let data = JSON.parse(window.sessionStorage.getItem("listTit"));
    if (data) {
      this.list = data;
    } else {
      this.$EventBus.$on("resData", (v) => {
        this.list = v;
      });
    }
    // 没有数据重新加载
    if (!this.list) {
      this.setTitle();
    }
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="stylus">
.container {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background: #fff;
  width: 100% !important;
  height: 90px !important;
}

header {
  .logo {
    float: left;
    margin-top: 24px;
    /* margin-left: -50px; */
  }

  .nav {
    /* float: right; */
    margin-left: 50px;

    li {
      float: left;
      line-height: 90px;
      padding: 0 14px;
      min-width: 118px;
      text-align: center;

      a {
        color: #000;
      }

      &:hover {
        background: #c10000;

        a {
          color: #fff;
        }
      }
    }

    .navli {
      float: left;
      position: relative;

      a {
        color: #000;
        display: block;
        font-size: 16px;
        line-height: 90px;
        padding: 0 10px;
      }

      .submenu {
        display: block;
        width: 100%;
        background: rgba(43, 58, 80, 0.7);
        padding: 10px 0;
        position: absolute;
        z-index: 99;
        left: 0px !important;
        margin: 0;
        list-style: none;
        box-sizing: border-box;

        li {
          margin: 3px 0;

          a {
            color: #fff;
            font-size: 13px;
            line-height: 26px;
            cursor: pointer;
            text-align: center;
          }

          a:hover {
            /* text-decoration: underline; */
          }
        }
      }
    }

    .navli:hover {
      background: #c10000;

      a {
        color: #fff;
      }
    }
  }

  .search {
    .el-input__inner {
      width: 200px;
      position: absolute;
      /* top: -116px; */
      /* right: -181px; */
      top: -25px;
      right: -140px;
    }
  }
}

.popFa {
  width: 100%;
  position: relative;

  .pop {
    position: absolute;
    left: 46%;
    top: 90px;
    /* transform: translate(-50%, -50%); */
  }
}

/* 新增搜索框 */
.searchAdd {
  display:none;
  height: 106px;
  width: 100%;
  background: rgba(43, 58, 80, 0.5);
  padding-top: 34px;
  box-sizing: border-box;

  .seaechBox {
    width: 540px;
    margin: 0 auto;
    /deep/.el-input__inner{
      border:1px solid transparent;
    }
  }
}

.el-input__inner {
  border-radius: 0;
}


</style>
<style>
.el-input-group__append {
  cursor: pointer;
  width: 128px;
  text-align: center;
  background: #c10000;
  border: 1px solid #c10000;
  border-radius: 0;
  color: #fff;
}
.el-col-13 {
  width: 65% !important;
}
.el-col-7 {
  width: 22% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/g_header.vue